import { doc, setDoc } from "firebase/firestore";
import {firestoreDb} from "./firebase";

export async function createUserDocument(user) {
    const userRef = doc(firestoreDb, "users", user.uid);
    await setDoc(userRef, {
        email: user.email,
        purchasedReveals: 0,
        purchasedRegisters: [],
    }, { merge: true }); // merge: true pozwala na aktualizację istniejących danych
}
